import { useState, useEffect } from "react";
import EditModal from "../../../common/Modals/EditModal";
import { ReactComponent as EditIcon } from "../../../../images/icons/edit-alternative.svg";

const LineItemNotes = ({ lineItem, updateLineItem, loading }) => {
  const [isNotesModalOpen, setNotesModalOpen] = useState(false);
  const [editValue, setEditValue] = useState(lineItem?.notes ?? "");

  // keep editValue in sync if lineItem.notes changes
  useEffect(() => {
    setEditValue(lineItem?.notes ?? "");
  }, [lineItem?.notes]);

  const handleSave = async () => {
    await updateLineItem("notes", editValue);
    setNotesModalOpen(false);
  };

  return (
    <div className="content">
      {/* Note Display */}
      {lineItem?.notes && (
        <div id="text-table" className="text-table smaller red">
          {lineItem.notes}

          {/* Edit Icon */}
          <div
            className="delete-symbol-2 no-margin"
            onClick={(e) => {
              e.preventDefault();
              setNotesModalOpen(true);
            }}
          >
            <div className="icon smaller w-embed">
              <EditIcon />
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      <EditModal
        isOpen={isNotesModalOpen}
        onClose={() => {
          setEditValue(lineItem?.notes ?? "");
          setNotesModalOpen(false)
        }}
        title="Edit Client Notes"
        icon={EditIcon}
        fields={[
          {
            placeholder: "Edit Client Notes",
            value: editValue,
            onChange: setEditValue,
            required: true,
          },
        ]}
        loading={loading}
        onSave={handleSave}
      />
    </div>
  );
};

export default LineItemNotes;
